export enum ESearchType {
  VectorSearch = 0,
  ExactVectorSearch = 1,
  RAGSearch = 2
}
